import {
  INITIAL_LOAD_SUCCESS,
  INITIAL_LOAD_FAILURE,
  INITIAL_LOAD,
} from "./initial.actions";
import { LOGIN_FAILURE } from "../../pages/login/login.actions";
import { withLoadingState } from "../shared";

const reducer = (state = {}, action) => {
  switch (action.type) {
    case INITIAL_LOAD_FAILURE:
    case INITIAL_LOAD_SUCCESS:
    case LOGIN_FAILURE:
      return {
        ...state,
        completed: true,
      };
    default:
      return state;
  }
};

export default withLoadingState({
  loadActionType: INITIAL_LOAD,
  successActionType: INITIAL_LOAD_SUCCESS,
  failureActionType: INITIAL_LOAD_FAILURE,
})(reducer);
